export default __webpack_public_path__ + "static/media/single-project-page-04-img18.741bd64c.jpg";